import { LogLevel } from "../enum/enum";
import { LogsService } from "../service/logs.service";

const _window = window as any;
const Android = (_window as any).Android;

export const NativeBridge = {
    checkForNative: async (): Promise<string> => {
        try {
            if (Android) {
                return String(Android.checkForNative());
            } else if (_window) {
                const data = await _window.webkit?.messageHandlers['snapNativeHandler'].postMessage({
                    methodName: 'checkForNative',
                    parameters: {}
                });
                return data?data:'';
            }
        } catch {
            return '';
        }
        return '';
    },
    closeWebView: async (merchant_data?: {
        action: string;
        method: string;
        merchant_params: { [key: string]: string };
    }) => {
        const currentUrl = window.location.href;
        try {
            if (Android) {
                LogsService.log({ level: LogLevel.INFO, message: `Closing WebView from Android - current URL: ${currentUrl}` });
                Android.closeWebView();
            } else if (_window) {
                LogsService.log({ level: LogLevel.INFO, message: `Closing WebView from iOS - current URL: ${currentUrl}` });
                await _window.webkit?.messageHandlers['snapNativeHandler'].postMessage({
                    methodName: 'closeWebView',
                    parameters: {}
                });
            }
        } catch {
            LogsService.log({ level: LogLevel.ERROR, message: `Error in closeWebview - current URL: ${currentUrl}` });
        }
    },
    orderSuccess: async (orderData: any) => {
        const currentUrl = window.location.href;
        try {
            if (Android) {
                Android.orderSuccess(JSON.stringify(orderData));
                LogsService.log({ level: LogLevel.INFO, message: `Sending order success to Android with data ${JSON.stringify(orderData)} current URL: ${currentUrl}` });
            } else if (_window) {
                LogsService.log({ level: LogLevel.INFO, message: `Sending order success to iOS with data ${JSON.stringify(orderData)} current URL: ${currentUrl}` });
                _window.webkit?.messageHandlers['snapNativeHandler'].postMessage({
                    methodName: 'orderSuccess',
                    parameters: {
                        orderData: orderData
                    }
                });
            }
        } catch {
            LogsService.log({ level: LogLevel.ERROR, message: `Error in orderSuccess - current URL: ${currentUrl}` });
        }
    }
};
